import React, { useState, useMemo } from "react";
import Select from "react-select";
// @ts-ignore
import countryList from "react-select-country-list";
// @ts-ignore
import Flag from "react-world-flags";
// @ts-ignore
import { allCountries  } from "country-telephone-data";


  // Create a map of country codes to dial codes
  interface DialCodeMap {
    [key: string]: string;
  }

  interface CountryOption {
    value: string;      // ISO code
    label: string;      // Country name
    dialCode: string;   // +91, +1, etc.
  }
interface Props {
  selectedCountry: CountryOption | null;
  onChange: (country: CountryOption) => void;
}



export default function CountrySelector({ selectedCountry, onChange }: Props) {
 
  
  const getDialCodeMap = (): DialCodeMap => {
    const dialCodeMap: DialCodeMap = {};
  
    allCountries.forEach((country: { iso2: string; dialCode: string }) => {
        dialCodeMap[country.iso2.toUpperCase()] = country.dialCode;
      });
  
    return dialCodeMap;
  };
  const dialCodeMap = useMemo(() => getDialCodeMap(), []);

  // Create country options with value, label, and dialCode
  const countryOptions: CountryOption[] = useMemo(() => {
    return countryList().getData().map((country:any) => {
      const countryCode = country.value;
      const dialCode = dialCodeMap[countryCode] ? `+${dialCodeMap[countryCode]}` : "";
  
      return {
        value: countryCode,
        label: country.label,
        dialCode: dialCode,
      };
    });
  }, [dialCodeMap]);

  const handleChange = (selected: CountryOption) => {
    onChange(selected); // call parent's handler
  }

  
  const formatOptionLabel = ({ value, label, dialCode }: any) => {
    return (
      <div style={{ display: "flex", alignItems: "center", }}>
      <Flag code={value}  style={{ marginRight: "10px",height:"20px" }} />
      <span>
        {label} ({value})
      </span>
      {dialCode && (
        <span style={{ marginLeft: "auto", color: "#666" }}>{dialCode}</span>
      )}
    </div>
    );
  };

 

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      width: "100%", 
      margin: "0 auto",
      height: "60px"
    }),
    menu: (provided: any) => ({
      ...provided,
      width: "100%", 
    }),
  };


  return (
    <div className="md:w-[200px]" >
      <Select
        options={countryOptions}
        value={selectedCountry}
        onChange={handleChange}
        formatOptionLabel={formatOptionLabel}
        styles={customStyles}
        placeholder="Select a country..."
        isSearchable={true}
      /> 
    </div>
  );
}
